function initMap() {

	// Custom Styles
	var styles = [
		{
			"featureType": "water",
			"elementType": "all",
			"stylers": [
				{
					"hue": "#7fc8ed"
				},
				{
					"saturation": 55
				},
				{
					"lightness": -6
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "labels",
			"stylers": [
				{
					"hue": "#7fc8ed"
				},
				{
					"saturation": 55
				},
				{
					"lightness": -6
				},
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#83cead"
				},
				{
					"saturation": 1
				},
				{
					"lightness": -15
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#f3f4f4"
				},
				{
					"saturation": -84
				},
				{
					"lightness": 59
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "labels",
			"stylers": [
				{
					"hue": "#ffffff"
				},
				{
					"saturation": -100
				},
				{
					"lightness": 100
				},
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#ffffff"
				},
				{
					"saturation": -100
				},
				{
					"lightness": 100
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "labels",
			"stylers": [
				{
					"hue": "#bbbbbb"
				},
				{
					"saturation": -100
				},
				{
					"lightness": 26
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#ffcc00"
				},
				{
					"saturation": 100
				},
				{
					"lightness": -35
				},
				{
					"visibility": "simplified"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#ffcc00"
				},
				{
					"saturation": 100
				},
				{
					"lightness": -22
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "poi.school",
			"elementType": "all",
			"stylers": [
				{
					"hue": "#d7e4e4"
				},
				{
					"saturation": -60
				},
				{
					"lightness": 23
				},
				{
					"visibility": "on"
				}
			]
		}
	]
  
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      // Set zoom level based on device type
      const zoomLevel = isMobile ? 3.4 : 5;

	// Init Map
      const map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: -33.0173829, lng: 133.0861966 },
        zoom: zoomLevel, // Make sure zoomLevel is defined
        disableDefaultUI: true,
        gestureHandling: "cooperative",
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: true,
        styles: styles, // Make sure styles is defined
      });
  
  	// Custom Marker
   // Set different icon sizes
    const iconSize = isMobile ? new google.maps.Size(20, 28) : new google.maps.Size(30, 40);
	var icon = {
		url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAyCAYAAAAweqkjAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAJqADAAQAAAABAAAAMgAAAAAyWjMjAAAEr0lEQVRYCcVZXWwUVRQ+Z7cthUJMY1BAedAoRIjQXQiBB2KM+uSDjYmIplgKpVv1QY0JiQkvJCQ+yguBxVoIIYJiQmP00RjDQ5HEXYuRBPxLBOJPbZoaC4Tt9vqdOzudmd2ZnXunu+UkO3PvPd/5zjf33p1zt2VKYqfGHqBbM88j9BliXk2KVqItH7E/iPFR6jraX9GSli/ptY1/a4/FhY2xSqVoqNhDZfU6EW8hQt/IeBbYS5Tmo9SfOY0HQT/ezITli90gP4RZWB9PWQfB/CMe6gDlMiN1UNpVX9ipsQ66XT4BQS/FEVn5mc/R4nQflng6Ki5a2PDlR6lUGsH+eTIqeF7jTD9Qa2s37dnwaxhPuDAtauYiZmp5WFDDxpjHqbVla5i42g2c/+U+Ks180XRR8nTy4JJLclZZUJhSmMGpzxDwRBWueV3JpabOIWdg9YLChoq7AHi2eSqimNVzeBXt8ns9lZ9eX0yT49cg7GE/YMHazDeoc/ka2rH6tuT0Zmxy/K17JkqUyISIhop5wpTa7Q7es7tPgyNsuLAOYtYmEHSBUukXaVH7SuJsm75Ln+hCAi4JWUuOFmrRBHdJyCyM/6M0vY3aN4zap3yBf6J9Hssygs28h8p0GGu01OePbzparrhLuTk+wo9AId+X/ahKlAcQseInKfjWprU4wpgeMg5nPkuDm04b4QUneBuraHFnbJV5bOqIOVaQtnjSWirCLGpiS/uYlbCOjstWeHK0uDM2ZRfcVLTW4gr7xzjVzJ2NxlgBTk9vsMITaS0VYfyTefDsm+ZYQdri+ZpEucIuSsfIlNpJx77rMcIKTvBWxt8K3BU2ahVL+GHxYWEvknqHAD+BjItfcNbGWotDnFetpIp/4YXYackjJekDHJFH6e66CWq7cj+O49totvwOeLZbcgHOk8SZBynHJe+J84WTmIFee7KGRpzEy7tPGN1vJcSmzjQ0RRKyVHquSngzJvvieFEOio8l4Zx3DPPPNJBZ49Zf34yh8CpKsFnnLckhkNy+k4onTNxLlw3hOuEgF/Q6Uck9lzQorOfxf6H6/TnvQjUkp+T2WVCYONo6j0DcDR+muU3JJTmrrFZY3yN38BU9WIVrYhe5dM5gilph4u/sOoHr1SC0Kb2rlVw15OHCdnAZb/T3atCNHpAckivEwoUJcKDrPPba5yExjRkSbskRYdHCJKA99Qb+bNn4Q6RwCncdqy+st+smYvfXiU/q2k8Od2S8V5KiIE6p+hql6qkoiNU48zcoPU/73/Jh8fVnTCKkTLTxPizprTACqzHh0FyBH8mhFPHCJKwvg6N3au4PHqFMRoPg0Fzx4Pil9HPkC2expC/7h4zbzJ9QLmt8zDabMTd7x7IBLO1vbtf4LjESa2F2wqTQplM7sd9KxjkEKzFVRTou3k6YsPV3XcJ+s3iFAKtj4qQE/XZ7zB97rPAxfry84h+qbfMZGsy+WjseP2I/Yy4nr+jHfvve7dbcxSeYhJZcWG4V3muLXsCLLuQ/azIGn8YkU5ZcmOTLrf8d1258GXCGq5jT7q743FHr+/yESbrB7Ch+xOzWFUKqBKd79Zi1lGYF5AvvknwaZP8DAStCUa+mxycAAAAASUVORK5CYII=",
        scaledSize: iconSize,
	};

    //DST Rural, 2330 Silverdale Rd, Silverdale NSW 2752, Australia
       new google.maps.Marker({
		position: { lat: -35.8885307, lng: 150.619873 },
		map: map,
		icon: icon
	});


   //36-42 West St, Bega NSW 2550, Australia
       new google.maps.Marker({
		position: { lat: -36.6650281, lng: 149.8241139 },
		map: map,
		icon: icon
	});

    

    //82 Cowabbie St, Coolamon NSW 2701, Australia
      new google.maps.Marker({
		position: { lat: -34.8173635, lng: 147.2002423 },
		map: map,
		icon: icon
	});


	// 12 Say St, East Wagga Wagga NSW 2650, Australia
	new google.maps.Marker({
		position: { lat: -35.1294857, lng: 147.4176564 },
		map: map,
		icon: icon
	});

	// DSW Direct Steel Wagga, 35 Moorong St, Wagga Wagga NSW 2650, Australia
	new google.maps.Marker({
		position: { lat: -35.1057735, lng: 147.3482638 },
		map: map,
		icon: icon
	});

    //Hovell St, Wodonga VIC 3690, Australia
        new google.maps.Marker({
		position: { lat: -36.1151194, lng: 146.8942469 },
		map: map,
		icon: icon
	 });
     
  
     //364-366 Urana Rd, Lavington NSW 2641, Australia
        new google.maps.Marker({
		position: { lat: -36.047657, lng: 146.9310455 },
		map: map,
		icon: icon
	 });
     
  

    //3-657 Wakool Rd, Deniliquin NSW 2710, Australia
       new google.maps.Marker({
		position: { lat: -35.5028335, lng: 144.7891115 },
		map: map,
		icon: icon
	});
     

     //Steel Supplies Mildura 1 Allen Drv Irymple VIC 3498
       new google.maps.Marker({
		position: { lat: -34.2398929, lng: 142.1641484 },
		map: map,
		icon: icon
	});


     //Miegel Engineering, 3 Howard Rd, Murray Bridge SA 5253, Australia
     new google.maps.Marker({
		position: { lat: -35.1429533, lng: 139.2710656 },
		map: map,
		icon: icon
	});

	// Perth
	new google.maps.Marker({
		position: { lat: -32.107162, lng: 115.7969829 },
		map: map,
		icon: icon
	});

 // Burnie 4x4 - TJM Authorised Stockist, 48-50 Bass Hwy, Cooee TAS 7320, Australia
	new google.maps.Marker({
		position: { lat: -41.0410194, lng: 145.8764953 },
		map: map,
		icon: icon
	});

//485 Hobart Rd, Youngtown TAS 7258, Australia
    	new google.maps.Marker({
		position: { lat: -41.4974193, lng: 147.1721438 },
		map: map,
		icon: icon
	});
}

